import React from 'react';
import { useIntl } from 'react-intl';
import { StatusMessage as CosmaStatusMessage } from 'is24-corecss';

import { toast } from 'react-toastify';
import { StatusMessageType } from '../../types/StatusMessageType';

type StatusMessageProps = {
  status: StatusMessageType;
  onClose?: () => void;
};

const isValid = (status: StatusMessageType) => status && status.titleCode && status.messageType;

export const notify = (status: StatusMessageType) => {
  if (isValid(status)) {
    toast(({ closeToast }) => <StatusMessage status={status} onClose={closeToast} />);
  }
};

const StatusMessage: React.FC<StatusMessageProps> = ({ status, onClose }: StatusMessageProps) => {
  const intl = useIntl();
  return (
    <CosmaStatusMessage
      statusType={status.messageType}
      statusStyle='toast'
      message={status.messageCode ? intl.formatMessage({ id: status.messageCode }) : status.details}
      headline={<span className='font-light'>{intl.formatMessage({ id: status.titleCode })}</span>}
      onClose={onClose}
    />
  );
};

export default StatusMessage;
